import { render } from "./ModalFrame.vue?vue&type=template&id=527ef158"
import script from "./ModalFrame.vue?vue&type=script&lang=js"
export * from "./ModalFrame.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/modals/ModalFrame.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "527ef158"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('527ef158', __exports__)) {
    api.reload('527ef158', __exports__)
  }
  
  module.hot.accept("./ModalFrame.vue?vue&type=template&id=527ef158", () => {
    api.rerender('527ef158', render)
  })

}


export default __exports__